// extracted by mini-css-extract-plugin
module.exports = {"page":"NotificationsPage_page__25nCI"};